import React from 'react'

import { ChipSwitch, ChipSwitchButton } from '../../components/ChipSwitch'
import { useFinancialsTableContext } from '../../components/financials-table'
import { View } from '../../components/line-stacked-bar-chart'
import { RevenueDataEnum, RevenueSettings } from './types'

export default function WidgetSettingsSection() {
  const { settings, setSettings } = useFinancialsTableContext<RevenueSettings>()

  const toggleSetting = (key: keyof RevenueSettings, value: RevenueSettings[typeof key]) => {
    setSettings({
      ...settings,
      [key]: value,
    })
  }

  return (
    <div className="flex flex-row space-x-5">
      <ChipSwitch size="small" label="Data">
        <ChipSwitchButton
          active={settings.isYoyChange}
          onClick={() => {
            toggleSetting(RevenueDataEnum.yoyChange, !settings.isYoyChange)
          }}
        >
          YoY Growth
        </ChipSwitchButton>
        <ChipSwitchButton
          active={settings.isYoyChangePct}
          onClick={() => {
            toggleSetting(RevenueDataEnum.yoyChangePct, !settings.isYoyChangePct)
          }}
        >
          YoY Growth %
        </ChipSwitchButton>
        <ChipSwitchButton
          active={settings.isSharePct}
          onClick={() => {
            toggleSetting(RevenueDataEnum.sharePct, !settings.isSharePct)
          }}
        >
          Share %
        </ChipSwitchButton>
      </ChipSwitch>

      <ChipSwitch size="small" label="Chart">
        <ChipSwitchButton
          active={settings.chartView === View.bars}
          leftContent="chartBar"
          size="none"
          className="h-6 w-6"
          onClick={() => {
            toggleSetting('chartView', View.bars)
          }}
        />
        <ChipSwitchButton
          active={settings.chartView === View.lines}
          leftContent="lineChartType"
          size="none"
          className="h-6 w-6"
          onClick={() => {
            toggleSetting('chartView', View.lines)
          }}
        />
      </ChipSwitch>
    </div>
  )
}
